<template>
  <div id="app" class="min-h-screen gray-background">
    <router-view />
  </div>
  <GrooveWidget />
</template>
<script>
export default {
  mounted() {}
}
</script>
<style lang="scss">
html {
  height: 100%;
}
body {
  height: 100%;
}

/* Toast custom css */
.Vue-Toastification__container.rentapp-toast {
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100vw;
  padding: 0;

  .Vue-Toastification__toast {
    width: 100vw;
    max-width: 100vw;
    min-height: 0;
    padding: 0px;
    border-radius: 0px;
    margin: 0;
  }
}
</style>
